export default "/_next/static/images/Google_AI_Studio_2025-12-06T00_24_50.650Z 18-80efd40b23de325b94d9469b10dc5269.png";